import usePaginatedRegisters from '@/modules/PaginatedRegisters.js'
import useNonPaginatedRegisters from '@/modules/NonPaginatedRegisters.js'
import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const non_paginated_confined_space_types = ref([])
const confined_space_types = ref([])
const total_confined_space_types = ref(0)
const confined_space_type_filters = ref({})
const filtered_confined_space_types = ref([])
const loading = ref(false)

export default function useConfinedSpaceTypes() {
  const {
    listRegisters,
    get_api_path,
    save_api_path,
    getAllRegisters,
    search_and_paginate_api_path,
    destroy_api_path,
    destroyRegister,
    saveRegister,
    getRegister,
  } = usePaginatedRegisters()

  search_and_paginate_api_path.value = '/api/confined_space_types/searchAndPaginate'
  get_api_path.value = '/api/confined_space_types/get/'
  save_api_path.value = '/api/confined_space_types/storeOrUpdate'
  destroy_api_path.value = '/api/confined_space_types/destroy/'

  const listConfinedSpaceTypes = async (page, per_page) => {
    loading.value = true

    return new Promise((resolve, reject) => {
      listRegisters(page, per_page, confined_space_type_filters.value)
        .then(response => {
          total_confined_space_types.value = response.data.meta.total
          confined_space_types.value = response.data.data
          resolve()
        })
        .catch(error => {
          console.log(error)
          reject()
        })
        .finally(() => (loading.value = false))
    })
  }

  const destroyConfinedSpaceType = async (id, index) => {
    destroyRegister(id).then(() => {
      confined_space_types.value.splice(index, 1)
    })
  }

  const { all_registers_api_path, listRegisters: listRegistersNoPagination } = useNonPaginatedRegisters()

  all_registers_api_path.value = '/api/confined_space_types/all'

  const listConfinedSpaceTypesNoPagination = async () => {
    return new Promise((resolve, reject) => {
      listRegistersNoPagination()
        .then(response => {
          non_paginated_confined_space_types.value = response.data.data
          resolve()
        })
        .catch(error => {
          console.log(error)
          reject()
        })
    })
  }

  const listConfinedSpaceTypesNoPaginationToCompany = async (company_id) => {
    return new Promise((resolve, reject) => {
      listRegistersNoPagination()
        .then(response => {
          non_paginated_confined_space_types.value = response.data.data.filter(
            confined_space => confined_space.company_id === company_id,
          )
          resolve()
        })
        .catch(error => {
          console.log(error)
          reject()
        })
    })
  }

  return {
    confined_space_types,
    non_paginated_confined_space_types,
    listConfinedSpaceTypesNoPagination,
    total_confined_space_types,
    confined_space_type_filters,
    loading,
    listConfinedSpaceTypesNoPaginationToCompany,
    listConfinedSpaceTypes,
    destroyConfinedSpaceType,
    getAllConfinedSpaceTypes: getAllRegisters,
    saveConfinedSpaceType: saveRegister,
    getConfinedSpaceType: getRegister,
  }
}
